import Vue from 'vue';
import Router from 'vue-router';
import DateOfBirth from '../views/DateOfBirth.vue';
import RadioButton from '../views/RadioQuestion.vue';
import Checkbox from '../views/CheckboxQuestion.vue';
import NameAndGender from '../views/NameGender.vue';
import Occupation from '../views/Occupation.vue';
import AddressDetails from '../views/AddressDetails.vue';
import ContactDetails from '../views/ContactDetails.vue';
import GpDetails from '../views/GpDetails.vue';
import Interpreter from '../views/Interpreter.vue';
import SpecialRequirements from '../views/SpecialRequirements.vue';
import ProblemLocations from '../views/ProblemLocations.vue';
import BriefDescription from '../views/BriefDescription.vue';
import Clinics from '../views/Clinics.vue';
import HowLong from '../views/HowLong.vue';
import OffWork from '../views/OffWork.vue';
import Result from '../views/Result.vue';
import Intro from '../views/Intro.vue';
import Timeout from '../views/Timeout.vue';
import Statement from '../views/Statement.vue';
import Endpoint from '../views/EndPoint.vue';
import Summary from '../views/Summary.vue';
import json from '../../public/api/data.json';

const createRoutes = function () {
  let routeData = json.questions
    .map(({ id, questionType }) => ({ path: `/${id}`, name: id.toLowerCase(), component: getComponent(questionType) }));
  routeData.unshift({ path: '/', redirect: '/Intro' });
  routeData.push({ path: '/Result', name: 'result', componenet: getComponent("") });
  routeData.push({ path: '/Timeout', name: 'timeout', component: Timeout })
  return routeData;
};

const getComponent = function (questionType) {
  switch (questionType) {
    case "Date":
      return DateOfBirth;
    case "RadioList":
      return RadioButton;
    case "Intro":
      return Intro;
    case "NameAndGender":
      return NameAndGender;
    case "Occupation":
      return Occupation;
    case "AddressDetails":
      return AddressDetails;
    case "ContactDetails":
      return ContactDetails;
    case "GpDetails":
      return GpDetails;
    case "Interpreter":
      return Interpreter;
    case "SpecialRequirements":
      return SpecialRequirements;
    case "ProblemLocations":
      return ProblemLocations;
    case "BriefDescription":
      return BriefDescription;
    case "Clinics":
      return Clinics;
    case "HowLong":
      return HowLong;
    case "OffWork":
      return OffWork;
    case "CheckboxList":
      return Checkbox;
    case "Statement":
      return Statement;
    case "Endpoint":
      return Endpoint;
    case "Summary":
      return Summary;
    default:
      return Result;
  }
};

Vue.use(Router)
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: createRoutes()
})